import * as z from "zod/v4";

export const claimsCreatedMonthSchema = z.object({
  month: z
    .string()
    .describe("ISO date (UTC) marking the first day of the month bucket"),
  claimCount: z.number().int().describe("Number of claims created that month"),
  claimRevenue: z
    .number()
    .describe(
      "Sum of analytics_totals_return_total_value across claims created that month",
    ),
});

export type ClaimsCreatedMonth = z.infer<typeof claimsCreatedMonthSchema>;

export const getClaimsCreated = {
  name: "getClaimsCreated" as const,
  input: z.object({
    startDate: z
      .string()
      .describe("Inclusive ISO timestamp lower bound on created_at"),
    endDate: z
      .string()
      .describe("Exclusive ISO timestamp upper bound on created_at"),
  }),
  output: z.object({ months: z.array(claimsCreatedMonthSchema) }),
};
